import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { Checkbox, SecondaryText, StyledFlex, Text } from '@dreryk/react-components';
import { FormContextValues, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { EmergencyNotificationInAppConfigurationEnabledFieldFormBeanPart } from './EmergencyNotificationInAppConfigurationEnabledField.types';

type EmergencyNotificationInAppConfigurationEnabledFieldProps = Pick<
   FormContextValues<EmergencyNotificationInAppConfigurationEnabledFieldFormBeanPart>,
   'register'
> & {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationInAppConfigurationEnabledField = (
   props: EmergencyNotificationInAppConfigurationEnabledFieldProps
): JSX.Element => {
   const defaultValue = Boolean(props.emergencyNotificationConfiguration.inAppConfiguration.enabled);

   return (
      <StyledFlex gap={'4px'} alignItems={'start'}>
         <Checkbox
            testId={'inAppConfigurationEnabled'}
            controller={props.register('inAppConfigurationEnabled')}
            defaultValue={defaultValue}
         />
         <StyledFlex direction={'column'}>
            <Text testId={'showInAppNotification'}>
               <Translate>{translationKeys.showInAppNotification}</Translate>
            </Text>
            <SecondaryText
               testId={'inAppNotificationsWillBeSentToTheFollowingPractitioners'}
               text={translationKeys.responseTeamPractitionersWillSeeEmergencyNotificationInApp}
            />
         </StyledFlex>
      </StyledFlex>
   );
};
